<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__body">
          <span class="lsoading-request" v-show="loading"></span>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
          >
            <h1 class="h2">Gerar Fatura Parcial</h1>
          </div>

          <div
            id="alert"
            class="alert alert-dismissible fade show  m-alert m-alert--outline mb-5 mt-4"
            :class="alert.color"
            role="alert"
            v-if="alert.message"
          >
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="alert.message = ''"
            ></button>
            <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
            ><br />
            {{ alert.reason }}
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="col-md-12">
                <label for="companies_month">
                  Clientes
                </label>
                <SelectCustomersMultiple @selected="selectedCustomer" />
              </div>
            </div>
          </div>

          <hr class="row mt-5 mb-3" />
          <div class="row">
            <div class="col-md-12 text-right"></div>
          </div>
          <div class="row mb-5">
            <div class="col-md-12 text-right">
              <button
                class="btn"
                :class="{
                  'btn-metal': !formIsValid,
                  'btn-focus': formIsValid,
                }"
                :disabled="!formIsValid || loading"
                @click="process"
              >
                <i class="fas fa-chevron-circle-sync" v-if="formIsValid"></i>
                <i class="fas fa-exclamation-triangle" v-else></i>
                Gerar
              </button>
            </div>
          </div>
          <hr class="row mt-5 mb-3" />
          <ProcessPartialInvoiceHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import ProcessPartialInvoiceHistory from '@/components/invoices/ProcessPartialInvoiceHistory';
import SelectCustomersMultiple from '@/components/forms/SelectCustomersMultiple';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  components: { ProcessPartialInvoiceHistory, SelectCustomersMultiple },
  name: 'GenerateInvoices',
  data() {
    return {
      data: {
        billing_month: '03/2021',
        customers: '',
        is_partial_invoice: 1,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      loading: false,
    };
  },
  computed: {
    formIsValid() {
      if (this.data.billing_month) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    process() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Enviando requisição...',
        reason: '',
      };

      this.loading = true;

      const currentDate = new Date();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      this.data.billing_month = `${month}/${year}`;

      const url = `${baseApiUrl}/v1/invoice/process`;
      axios
        .post(url, this.data)
        .then((res) => {
          this.logMessageForm(res);
          this.loading = false;
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    validateCustomersIds($event) {
      if (!isNaN($event.key) || $event.key === ',') {
        return true;
      }
      $event.preventDefault();
    },
    selectedCustomer(customersId) {
      this.data.customers = customersId.join(',');
    },
  },
};
</script>
